import React from "react";

const TagSelectionPanel = ({
    series,
    tags,
    tagsLoading,
    tagsError,
    layout,
    selectedCount,
    stringNote,
    exporting,
    exportMessage,
    isStringChart,
    onTagChange,
    onColorChange,
    onAxisChange,
    onToggleVisible,
    onRemove,
    onAdd,
    onExport,
}) => (
    <section className="graph-page__card" aria-labelledby="select-tags-heading">
        <div className="graph-page__card-head">
            <h2 id="select-tags-heading">Select Tags</h2>
            <p>{tagsLoading ? "Loading tags…" : `${tags.length} tags available`}</p>
        </div>
        {tagsError && <p className="graph-page__banner is-error" role="alert">{tagsError}</p>}
        <div className="graph-page__selectors">
            {series.map((item) => (
                <div key={item.chart.id} className="graph-page__selector">
                    <div className="graph-page__field">
                        <label htmlFor={`history-tag-${item.chart.id}`}>Tag {item.index + 1}</label>
                        <select
                            id={`history-tag-${item.chart.id}`}
                            value={item.chart.tagId}
                            onChange={(event) => onTagChange(item.chart.id, event.target.value)}
                        >
                            <option value="">Select a tag</option>
                            {tags.map((tag) => (
                                <option key={tag.id} value={tag.id}>
                                    {tag.signal_type === "STRING" || tag.opc_data_type === "String" ? `${tag.name} (String)` : tag.name}
                                </option>
                            ))}
                        </select>
                        {isStringChart(item.chart) && <p className="graph-page__banner is-warn" role="status">{stringNote}</p>}
                    </div>
                    <div className="graph-page__field graph-page__field--color">
                        <label htmlFor={`history-color-${item.chart.id}`}>Color</label>
                        <input
                            id={`history-color-${item.chart.id}`}
                            type="color"
                            value={item.color}
                            aria-label={`Color for ${item.label}`}
                            onChange={(event) => onColorChange(item.chart.id, event.target.value)}
                        />
                    </div>
                    {layout === "combined" && (
                        <div className="graph-page__field graph-page__field--axis">
                            <label htmlFor={`history-axis-${item.chart.id}`}>Y axis</label>
                            <select
                                id={`history-axis-${item.chart.id}`}
                                value={item.chart.yAxis === "y1" ? "y1" : "y"}
                                onChange={(event) => onAxisChange(item.chart.id, event.target.value)}
                            >
                                <option value="y">Left axis</option>
                                <option value="y1">Right axis</option>
                            </select>
                        </div>
                    )}
                    <button type="button" className="graph-page__button" aria-pressed={item.chart.visible !== false} onClick={() => onToggleVisible(item.chart.id)}>
                        {item.chart.visible === false ? "Show series" : "Hide series"}
                    </button>
                    {selectedCount > 1 && (
                        <button type="button" className="graph-page__button graph-page__button--danger" onClick={() => onRemove(item.chart.id)}>
                            Remove
                        </button>
                    )}
                </div>
            ))}
        </div>
        <div className="graph-page__actions">
            <button type="button" className="graph-page__button" onClick={onAdd}>+ Add New Tag</button>
            <button type="button" className="graph-page__button graph-page__button--export" onClick={onExport} disabled={exporting}>
                {exporting ? "Exporting…" : "Download Excel"}
            </button>
        </div>
        {exportMessage && <p className="graph-page__banner" role="status">{exportMessage}</p>}
    </section>
);

export default TagSelectionPanel;
